import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { ArrowRight } from 'lucide-react';

const ROLES = [
  { value: 'athlete', label: 'Athlete' },
  { value: 'parent', label: 'Parent' },
  { value: 'coach', label: 'Coach' },
  { value: 'other', label: 'Other' },
];

export default function ProfileSetupCard({
  role, sport, level,
  onRoleChange, onSportChange, onLevelChange,
  onSave, saving,
}) {
  return (
    <Card className="border-2 border-[#004C54]/30 bg-[#F0F4F4]" data-testid="profile-setup-card">
      <CardContent className="p-5 sm:p-6">
        <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-[#004C54] font-semibold mb-2">
          Personalize your coach
        </div>
        <h2 className="font-heading text-lg font-bold mb-3">Tell us about you</h2>
        <div className="grid sm:grid-cols-3 gap-3 mb-4">
          <div>
            <label className="text-xs font-semibold text-foreground/70 mb-1.5 block">Role</label>
            <Select value={role} onValueChange={onRoleChange}>
              <SelectTrigger data-testid="profile-role"><SelectValue placeholder="Select role" /></SelectTrigger>
              <SelectContent>
                {ROLES.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs font-semibold text-foreground/70 mb-1.5 block">Sport (optional)</label>
            <Input value={sport} onChange={(e) => onSportChange(e.target.value)} placeholder="e.g. Soccer" data-testid="profile-sport" />
          </div>
          <div>
            <label className="text-xs font-semibold text-foreground/70 mb-1.5 block">Level (optional)</label>
            <Input value={level} onChange={(e) => onLevelChange(e.target.value)} placeholder="e.g. Middle School, High School Varsity, College D2" data-testid="profile-level" />
          </div>
        </div>
        <Button onClick={onSave} disabled={saving} className="bg-[#004C54] hover:bg-[#003a40] text-white" data-testid="save-profile">
          {saving ? 'Saving...' : 'Save profile'}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
}
